<template>
  <div class="container-inputrich">
    <div
      v-if="isRender"
      ref="text-input"
      :class="['text-input', { 'is-invalid': isValid === false || forceIsValid === false }, { disabled }]"
      :contenteditable="contenteditable"
      @keydown="onKeydown"
      @click="onClick"
      v-html="html"
    />
    <div
      v-if="helper"
      class="helper">
      {{ helper }}
    </div>
    <div
      v-click-outside="hideVariableDowndown"
      v-if="variable.show"
      class="variables">
      <ul>
        <li
          v-for="(item, index) in variables"
          :key="index"
          :class="[{ hover: variable.hoverIndex === index }]"
          @click="onSelectVariable(item)"
          @mouseover="onMouseOver(index)"
          @mouseleave="onMouseLeave"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { cloneDeep } from 'lodash'
import { PAYROLL_CONDITION_VARIABLE_TRANSLATE } from '@/helpers/enum'

export default {
  directives: {
    ClickOutside,
  },

  props: ['value', 'variables', 'helper', 'disabled'],

  data () {
    return {
      variable: {
        show: false,
        hoverIndex: null,
      },
      html: null,
      htmlClone: null,
      forceIsValid: null,
      input: null,
      isRender: true,
    }
  },

  computed: {
    contenteditable () {
      return !this.disabled
    },
    isValid () {
      if (this.htmlClone === null) {
        return null
      }
      if (this.variable.show === true) {
        return null
      }
      const result = this.getResult()
      const valid = result !== null
      if (valid && this.$refs['text-input'].innerHTML.length) {
        this.forceIsValid = null
      }
      this.$emit('update:valid', valid)
      return valid
    },
  },

  created () {
    this.input = this.value
    this.html = this.convertInputToHtml()
    this.cloneHtml()
    this.$emit('update:validateForm', this.validateForm)
    this.$emit('update:clearForm', this.clearForm)
  },

  methods: {
    onClick (e) {
      if (e.target.tagName === 'SPAN') {
        e.target.remove()
      }
    },
    onMouseOver (index) {
      this.variable.hoverIndex = index
    },
    onMouseLeave () {
      this.variable.hoverIndex = null
    },
    onSelectVariable ({ code, name }) {
      const tag = this.getTag(code, name)
      this.html = this.$refs['text-input'].innerHTML.replace('@', tag)
      this.cloneHtml()
      this.emitValue()
      this.hideVariableDowndown()
      this.onMouseLeave()
      this.$nextTick(() => {
        var target = this.$refs['text-input']
        const range = document.createRange()
        const sel = window.getSelection()
        range.selectNodeContents(target)
        range.collapse(false)
        sel.removeAllRanges()
        sel.addRange(range)
        target.focus()
        range.detach()
        target.scrollTop = target.scrollHeight
      })
    },
    onKeydown (e) {
      const { variable, variables } = this
      if (e.key === 'Enter') {
        if (variable.show && variable.hoverIndex !== null) {
          const item = variables[variable.hoverIndex]
          this.onSelectVariable(item)
        }
        return e.preventDefault()
      } else if (e.key === ' ') {
        return e.preventDefault()
      } else if (e.key === '@') {
        this.showVariableDowndown()
      } else if (e.key === 'ArrowDown' && variable.show) {
        if (variable.hoverIndex === null || variable.hoverIndex >= (variables.length - 1)) {
          this.variable.hoverIndex = 0
        } else {
          this.variable.hoverIndex++
        }
        return e.preventDefault()
      } else if (e.key === 'ArrowUp' && variable.show) {
        if (variable.hoverIndex === null || variable.hoverIndex <= 0) {
          this.variable.hoverIndex = this.variables.length - 1
        } else {
          this.variable.hoverIndex--
        }
        return e.preventDefault()
      } else {
        this.hideVariableDowndown()
      }
      this.cloneHtml()
      this.emitValue()
    },
    showVariableDowndown () {
      this.variable.show = true
    },
    hideVariableDowndown () {
      this.variable.show = false
    },
    cloneHtml () {
      setTimeout(() => {
        this.htmlClone = cloneDeep(this.$refs['text-input'].innerHTML)
      }, 10)
    },
    emitValue () {
      setTimeout(() => {
        let input = null
        if (this.isValid && !this.variable.show) {
          input = this.convertHtmlToVariable()
        }
        this.$emit('input', input)
      }, 10)
    },
    convertHtmlToVariable () {
      try {
        let str = this.htmlClone
        const tagMatches = this.htmlClone.match(/<span(.*?)>(.*?)<\/span>/gi)
        if (tagMatches) {
          for (const tag of tagMatches) {
            const nameMatches = tag.match(/<span(.*?)data-code="(.*?)"(.*?)>(.*?)<\/span>/i)
            if (nameMatches) {
              try {
                const fullTag = nameMatches[0]
                const code = nameMatches[2]
                str = str.replaceAll(fullTag, `{{${code}}}`)
              } catch (e) {
                return null
              }
            }
          }
        }
        return str
      } catch (e) {
        return null
      }
    },
    convertHtmlToFakeData () {
      try {
        let str = this.htmlClone
        const tagMatches = this.htmlClone.match(/<span(.*?)>(.*?)<\/span>/gi)
        if (tagMatches) {
          for (const tag of tagMatches) {
            const nameMatches = tag.match(/<span(.*?)data-code="(.*?)"(.*?)>(.*?)<\/span>/i)
            if (nameMatches) {
              try {
                const fullTag = nameMatches[0]
                const code = nameMatches[2]
                str = str.replaceAll(fullTag, '0')
              } catch (e) {
                return null
              }
            }
          }
        }
        return str
      } catch (e) {
        return null
      }
    },
    convertInputToHtml () {
      if (!this.input) return null
      let str = this.input
      const inputMatches = this.input.match(/{{(.*?)}}/gi)
      if (inputMatches) {
        for (const input of inputMatches) {
          const codeMatches = input.match(/{{(.*?)}}/i)
          const fullCode = codeMatches[0]
          const code = codeMatches[1]
          const name = this.$t(PAYROLL_CONDITION_VARIABLE_TRANSLATE[code])
          const tag = this.getTag(code, name)
          str = str.replaceAll(fullCode, tag)
        }
        return str
      } else {
        return this.input
      }
    },
    getResult () {
      try {
        return eval(this.convertHtmlToFakeData())
      } catch (e) {
        return null
      }
    },
    validateForm () {
      if (!this.$refs['text-input'].innerHTML.length) {
        this.forceIsValid = false
      }
    },
    clearForm () {
      const oldValue = cloneDeep(this.input)
      const newVal = cloneDeep(this.value)
      this.isRender = false
      this.$nextTick(() => {
        this.input = this.value
        this.html = this.convertInputToHtml()
        this.isRender = true
        if (oldValue !== newVal) {
          setTimeout(() => this.validateForm(), 100)
        }
      })
    },
    getTag (code, name) {
      return `<span contenteditable="false" class="badge badge-secondary" data-code="${code}" data-name="${name}">${name}</span>`
    },
  },
}
</script>

<style scoped>
.container-inputrich {
  position: relative;
}

.text-input {
  padding: .375rem .75rem;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  min-height: 35px;
}

.text-input.is-invalid {
  border-color: #ea848d;
}

.text-input.disabled {
  background-color: #e9ecef;
}

.text-input.is-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
}

.text-input /deep/ span:hover {
  cursor: pointer;
  background-color: #dc3545;
}

.variables {
  position: absolute;
  left: 0;
  bottom: -6px;
  transform: translateY(100%);
  width: 100%;
  border-radius: .25rem;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  z-index: 1;
}

.variables ul {
  padding: 6px 0 6px 0;
  margin: 0;
}

.variables li {
  padding: .375rem .75rem;
  cursor: pointer;
}

.variables li.hover {
  background-color: #f8f9fa;
}

.helper {
  position: absolute;
  left: 2px;
  bottom: -4px;
  transform: translateY(100%);
  width: 100%;
  font-size: 11px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseInputVariable.vue